import React from 'react'
import CordedExample from '../../assets/images/corded-image-example.webp'
import { ReactComponent as OutlinedInfo } from '../../assets/icons/outlined-info.svg'

const CushionCordingWarning = ({ acceptModal, acceptedCordingWarning }) => {
  return (
    <div className={`content-container ${acceptedCordingWarning ? 'accepted' : ''}`}>
      <OutlinedInfo width={30} height={30} className="info-icon" />
      <img src={CordedExample} className="side-image" alt="modal" />
      <div className="content">
        <p className="modal-description">
          Cushion Pros cuts our cording on the bias. This means that your cording fabric will not
          align with your main fabric. (See picture for example). This is to ensure that the cord
          will not unravel and last for years to come.
        </p>
        <button type="button" className="modal-button accept" onClick={acceptModal}>
          <span>OK</span>
        </button>
      </div>
    </div>
  )
}

export default CushionCordingWarning
